import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export interface State {
  id: string;
  name: string;
  abbreviation: string;
  cohort: 1 | 2 | 3;
  isActive: boolean;
}

// Hardcoded "Select State" placeholder
export const SELECT_STATE: State = {
  id: 'select-state',
  name: 'Select State',
  abbreviation: 'SS',
  cohort: 3,
  isActive: true,
};

/**
 * Fetches states from Firebase 'states-prod' collection
 * Only returns states where isActive === true
 * Returns SELECT_STATE as the first element, followed by sorted states
 * @returns {Promise<State[]>} Promise with array of State objects
 */
export async function fetchStates(): Promise<State[]> {
  try {
    const STATES_COLLECTION =
      process.env.REACT_APP_STATES_COLLECTION || 'states-prod';
    const collectionRef = collection(db, STATES_COLLECTION);
    const snapshot = await getDocs(collectionRef);
    const states = snapshot.docs
      .map(
        (doc) =>
          ({
            id: doc.id,
            ...doc.data(),
          } as State)
      )
      .filter((state) => state.isActive === true)
      .sort((a, b) => a.name.localeCompare(b.name));

    return [SELECT_STATE, ...states];
  } catch (error) {
    console.error('Error fetching states:', error);
    throw error;
  }
}
